__turbopack_context__.v({
  "container": "x0GsEq_container",
  "description": "x0GsEq_description",
  "title": "x0GsEq_title",
});
